import React from "react";
import {Container} from "@mui/material";
import HideAppBar from "../header/HideAppBar";
import {AppPageStyle} from "../../../styles/components/AppPageStyle";

const AppPage = ({
	appBarProps = {},
	children,
	containerClassName,
	containerComponent = "article",
	containerProps = {},
	mainClassName,
	standardBackground = true,
	title,
}) => {
	const classes = AppPageStyle();
	const {className: containerPropsClassName, ...restContainerProps} = containerProps;
	const resolvedContainerClassName = [containerClassName, containerPropsClassName].filter(Boolean).join(" ");
	const resolvedMainClassName = [standardBackground && classes.root, mainClassName].filter(Boolean).join(" ");

	return (
		<main className={resolvedMainClassName || undefined}>
			<HideAppBar title={title} {...appBarProps}/>
			<Container
				maxWidth={false}
				component={containerComponent}
				{...restContainerProps}
				className={resolvedContainerClassName || undefined}
			>
				{children}
			</Container>
		</main>
	);
};

export default React.memo(AppPage);
